import React from 'react'

import { asyncComponent } from '@jaredpalmer/after'
import Loader from './components/Loader'
import NotFound from './views/NotFound'

export default [
  {
    path: '/',
    exact: true,
    component: asyncComponent({
      loader: () => import('./views/Home'),
      Placeholder: () => <Loader />
    })
  },
  {
    path: '/parody/:slug',
    exact: true,
    component: asyncComponent({
      loader: () => import('./views/Parody'),
      Placeholder: () => <Loader />
    })
  },
  {
    path: [
      '/tag/:slug',
      '/artist/:slug',
      '/character/:slug',
      '/language/:slug'
    ],
    exact: true,
    component: asyncComponent({
      loader: () => import('./views/Tag'),
      Placeholder: () => <Loader />
    })
  },
  {
    path: '/:parody/:slug',
    exact: true,
    component: asyncComponent({
      loader: () => import('./views/Doujin'),
      Placeholder: () => <Loader />
    })
  },
  {
    path: '/:parody/:slug/related',
    exact: true,
    component: asyncComponent({
      loader: () => import('./views/Related'),
      Placeholder: () => <Loader />
    })
  },
  {
    path: '/:parody/:slug/read/:page',
    exact: true,
    component: asyncComponent({
      loader: () => import('./views/Reader'),
      Placeholder: () => <Loader />
    })
  },
  {
    path: '/parodies',
    exact: true,
    component: asyncComponent({
      loader: () => import('./views/Parodies'),
      Placeholder: () => <Loader />
    })
  },
  {
    path: ['/tags', '/artists', '/characters'],
    exact: true,
    component: asyncComponent({
      loader: () => import('./views/Tags'),
      Placeholder: () => <Loader />
    })
  },
  {
    path: '/search',
    exact: true,
    component: asyncComponent({
      loader: () => import('./views/Search'),
      Placeholder: () => <Loader />
    })
  },
  {
    path: '/contact',
    exact: true,
    component: asyncComponent({
      loader: () => import('./views/Contact'),
      Placeholder: () => <Loader />
    })
  },
  {
    path: '/2257',
    exact: true,
    component: asyncComponent({
      loader: () => import('./views/Underage'),
      Placeholder: () => <Loader />
    })
  },
  {
    // there is no need to declare path variable
    // react router will pick this component as fallback
    component: NotFound
  }
]
